module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax.absY",
      value: (-0.9),
      expression: "-0.9",
      modifiers: {
        "absY": true
      }
    }],
    staticClass: "h1title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax.absY",
      value: (1.2),
      expression: "1.2",
      modifiers: {
        "absY": true
      }
    }],
    staticClass: "h1title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.ballPos), function(ball) {
    return _c('i', {
      directives: [{
        name: "parallax",
        rawName: "v-parallax.centerX",
        value: (ball.parallax),
        expression: "ball.parallax",
        modifiers: {
          "centerX": true
        }
      }],
      style: (ball.style)
    })
  })], 2), _vm._v(" "), _c('my-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09efc8b3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParallaxDemo.vue
// module id = 12
// module chunks = 0